// Client-side zoeken/filteren voor de resellerlijst-sectie.
// Progressive enhancement: zonder JS blijft de volledige lijst zichtbaar.
class ResellerListComponent extends HTMLElement {
  #controller = new AbortController();

  /** @type {string} */
  activeType = '';

  connectedCallback() {
    const { signal } = this.#controller;

    this.searchInput = this.querySelector('[data-reseller-search]');
    this.filterButtons = Array.from(this.querySelectorAll('[data-reseller-filter]'));

    this.searchInput?.addEventListener('input', () => this.#update(), { signal });
    this.querySelector('[data-reseller-search-btn]')?.addEventListener('click', () => this.#update(), { signal });

    for (const button of this.filterButtons) {
      button.addEventListener('click', () => this.#setType(button), { signal });
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /** @param {HTMLElement} activeButton */
  #setType(activeButton) {
    this.activeType = activeButton.dataset.resellerFilter || '';

    for (const button of this.filterButtons) {
      button.setAttribute('aria-pressed', String(button === activeButton));
    }

    this.#update();
  }

  #update() {
    const query = (this.searchInput?.value || '').trim().toLowerCase();
    let visibleCount = 0;

    for (const card of this.querySelectorAll('[data-reseller-card]')) {
      const matchesType = !this.activeType || card.dataset.type === this.activeType;
      const matchesQuery = !query || (card.dataset.search || '').includes(query);
      const visible = matchesType && matchesQuery;

      card.hidden = !visible;
      if (visible) visibleCount += 1;
    }

    for (const group of this.querySelectorAll('[data-reseller-group]')) {
      group.hidden = !group.querySelector('[data-reseller-card]:not([hidden])');
    }

    const empty = this.querySelector('[data-reseller-empty]');
    if (empty) empty.hidden = visibleCount > 0;
  }
}

if (!customElements.get('reseller-list-component')) {
  customElements.define('reseller-list-component', ResellerListComponent);
}
